module.exports = __webpack_public_path__ + "img/consult_info2.125b1ce9.png";